module.exports = __webpack_public_path__ + "static/img/阅读活动.25032a74.png";